export default {
  'Screenshot': 'スクリーンショット',
}